/** One answer on a size's dot plot: where it sits from the lowest answer (0%) to the highest (100%), and how high it stacks. */
export interface Dot { hours: number; x: number; level: number }

/** Every answer gets its own dot. Tied answers are normal (they come from fixed hour cards), so they stack instead of hiding. */
export function dotLayout(hours: number[]): Dot[] {
  const sorted = [...hours].sort((a, b) => a - b);
  const lo = sorted[0] ?? 0;
  const hi = sorted[sorted.length - 1] ?? lo;
  const seen = new Map<number, number>();
  return sorted.map(h => {
    const level = seen.get(h) ?? 0;
    seen.set(h, level + 1);
    return { hours: h, x: hi === lo ? 50 : ((h - lo) / (hi - lo)) * 100, level };
  });
}
